import {
  Typography,
  TypographyList,
  TypographyListItem,
} from '@gogame/components';
import React from 'react';
import { useNumberFormat } from '@gogame/intl-ts';

export default ({ value }) => {
  const format = useNumberFormat();
  if (!value.totalCount) {
    return null;
  }
  const moreLabel = value.extraCount
    ? `+ ${format(value.extraCount)} more...`
    : null;
  return (
    <TypographyList
      limit={1}
      count={value.totalCount}
      unitsLabel={'UIDs'}
      disableTooltip={true}
    >
      {value.umIds.map((id) => (
        <TypographyListItem>{id}</TypographyListItem>
      ))}
      {moreLabel ? <Typography>{moreLabel}</Typography> : null}
    </TypographyList>
  );
};
